/* eslint-disable no-underscore-dangle */
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import elearningReducer from './reducers/elearningReducer';
import libraryReducer from './reducers/libraryReducer';
import topicsReducer from './reducers/topicReducer';
import uiReducer from './reducers/uiReducer';
import userReducer from './reducers/userReducer';
import eventsReducer from './reducers/eventReducer';
import postsReducer from './reducers/postReducer';
import activitiesReducer from './reducers/activityReducer';
import searchBarReducer from './reducers/searchBarReducer';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const initialState = {};

const middleware = [thunk];

const reducers = combineReducers({
  user: userReducer,
  elearning: elearningReducer,
  library: libraryReducer,
  topics: topicsReducer,
  events: eventsReducer,
  UI: uiReducer,
  posts: postsReducer,
  activities: activitiesReducer,
  searchBar: searchBarReducer,
});

export type RootState = ReturnType<typeof reducers>;

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducers,
  initialState,
  composeEnhancers(applyMiddleware(...middleware))
);

export default store;
